import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
import { SetTenant } from "../../../../../../redux/feature/TenantSlice";
import { useState, useEffect } from "react";
import { getListTenant } from "../requests/request";

interface Tenant {
    id: number;
    Name: string;
    Domain: string;
}

export default function SelectTenantstora() {
    const tenantId = useAppSelector(state => state.TenantSlice.id);
    const dispatch = useAppDispatch();
    const [tenants, setTenants] = useState<Tenant[]>([]); // Especifica el tipo explícitamente

    useEffect(() => {
        getListTenant().then((response: { data: Tenant[] }) => {
            setTenants(response.data);
            const storedTenantId = localStorage.getItem('tenantId');
            
            // Verificar si ya hay un tenant seleccionado almacenado localmente
            if (storedTenantId) {
                const storedTenant = response.data.find(tenant => tenant.id.toString() === storedTenantId);
                if (storedTenant) {
                    // Si se encuentra el tenant almacenado localmente, establecerlo como seleccionado
                    dispatch(SetTenant(Number(storedTenantId)));
                } else {
                    // Si el tenant almacenado localmente no se encuentra en la lista actual, seleccionar el primer elemento
                    const defaultTenant = response.data[0];
                    dispatch(SetTenant(defaultTenant.id));
                    localStorage.setItem('tenantId', defaultTenant.id.toString());
                    localStorage.setItem('tenantName', defaultTenant.Name);
                }
            } else {
                // Si no hay tenant almacenado localmente, seleccionar el primer elemento
                if (response.data.length > 0) {
                    const defaultTenant = response.data[0];
                    dispatch(SetTenant(defaultTenant.id));
                    localStorage.setItem('tenantId', defaultTenant.id.toString());
                    localStorage.setItem('tenantName', defaultTenant.Name);
                }
            }
        });
    }, [dispatch]);

    const handleTenantChange = (e:any) => {
        const selectedId = Number(e.target.value);
        const selectedTenant = tenants.find(tenant => tenant.id === selectedId); // Ahora TypeScript sabe que 'tenants' es un array de 'Tenant'
        if (selectedTenant) {
            dispatch(SetTenant(selectedId));
            localStorage.setItem('tenantId', selectedTenant.id.toString());
            localStorage.setItem('tenantName', selectedTenant.Name);
        }
    };

    return (
        <div>
            <label className='fw-bolder fs-7 mb-0'>Tenant</label>
            <select
                style={{ height: 'auto', paddingTop: '0', paddingBottom: '0' }}
                required
                className="form-select form-select-solid bg-light-info text-info border-gray-400 w-100px"
                aria-label="Select example"
                onChange={handleTenantChange}
                value={tenantId}
            >
                {
                    tenants.map((tenant: Tenant, i: number) => // Especifica el tipo de 'tenant' y 'i'
                        <option key={i} value={tenant.id}>{tenant.Name}</option>
                    )
                }
            </select>
        </div>
    );
}